module.exports = __webpack_public_path__ + "static/media/jasper-32.d22f7f61.jpg";